import React from "react";

// import Footer from "../Global/Footer";
import Header from "../Global/Header";

import { Link } from "react-router-dom";
import { Path } from "../Path.js";
import Mobroadmap from "./Mobroadmap";
import Mobroad from "./Mobroad";

export function Moblanding() {
  return (
    <>
      {/* Mobile Banner */}

      <div id="banner" className="container-fluid mob-banner">
        <Header />
        <div className="row">
          <div className="col-sm-4 picture">
            <img src={"images/banner.png"} alt="banner-imag" className="banner-pic floating" />
          </div>
          <div className="col-sm-8">
            <h1 className="home_heading mob">
              Hold{" "}
              <span className="change-color">
                $LITTLE <br />
              </span>
              Earn Revenue.
            </h1>
            <b>
              <p className="banner-para first mob-firstpara">
                And get access to a world of staking, holding and using like
                never seen before.
              </p>
            </b>
            <p className="banner-para home_p mob-secondpara">
              $LITTLE is the Little Billionaires utility token. <br />
              Earn $LITTLE as an NFT holder through
              <br /> staking, get rewarded with MATIC tokens every day for
              owning your $LITTLE and enjoy
              <br /> many exclusive benefits associated
              <br /> with this token.
            </p>
            <div className="btn-block mob-btn">
              <a
                href={Path + "Whitepaper_FINAL_1.1-2.pdf"}
                target="_blank"
                className="whitepaper"
                rel="noreferrer"
              >
                <button className="custom-btn btn-banner">Whitepaper</button>
              </a>
              <Link className="whitepaper" to="/">
                <button className="custom-btn btn-banner second">
                  Get NFT
                </button>
              </Link>
            </div>
          </div>
          {/* <div className="col-sm-4 picture">
      <img src={'images/banner.png'} className='banner-pic floating'/>
    </div> */}
        </div>
      </div>

      {/* Mobile Banner */}

      {/* Mobile Become */}

      <div id="unique" className="container-fluid">
        <div className="row">
          <h2 className="heading mob-heading">
            Become a part of Unique Ecosystem
          </h2>
          <p className="para-sub home_p">
            Earn <b>$LITTLE</b> as a utility token by staking your
            <br /> NFT and get rewarded daily in MATIC
          </p>
        </div>

        <div className="row unique">
          <div className="col-sm-4">
            <div className="price-section mob_price-section">
              <article className="home_price_table">
                <img src={"images/box.png"} alt="earn-imag" className="cards" />
                <h3 className="utilities-head mob-mainheading main-mobheading">
                  Earn $LITTLE
                </h3>
                <p className="little_para home_p mob-p">
                  Stake your Little Billionaire NFT
                  <br /> in your personal user panel
                  <br /> and get daily rewards in
                  <br /> $LITTLE tokens credited to
                  <br /> your balance.
                </p>
              </article>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="price-section">
              <article className="home_price_table">
                <img src={"images/3.png"} alt="eco-imag" className="cards" />
                <h3 className="utilities-head mob-mainheading main-mobheading">
                  Use the Ecosystem
                </h3>
                <p className="little_para home_p mob-p">
                  Benefit from a variety of utilities like Launchpads, Liquidity
                  providing <br />
                  and a Marketplace where $LITTLE <br />
                  is the center of payment.
                </p>
              </article>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="price-section">
              <article
                className="home_price_table matic_table"
                style={{ marginLeft: "0" }}
              >
                <img src={"images/4.png"} alt="earn-imag" className="cards" />
                <h3 className="utilities-head mob-mainheading main-mobheading">
                  Earn MATIC
                </h3>
                <p className="little_para home_p mob-p">
                  $LITTLE is based on the
                  <br /> Polygon network. Hold your
                  <br /> $LITTLE tokens and get
                  <br /> MATIC as a reward which you <br />
                  can withdraw at any time.
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile become */}

      {/* Little Utilities */}

      <div id="utilities" className="container-fluid">
        <div className="row">
          <h2 className="heading mob-heading">$LITTLE Utilities</h2>
          <p className="para-sub utilities_para home_p mob-para">
            Benefit from a handful of unique utilities and experience the power
            of a token that proves its value right from the start
          </p>
        </div>

        <div className="row utility">
          <div className="col-sm-6">
            <ul className="social-network social-circle">
              <li>
                <ul className="social list mob-sociallists">
                  <li className="icon-text effecthov">
                    <img src={"images/utility1.png"} alt="util-imag" />
                  </li>
                  <li className="utility para">
                    <h3 className="utilities-head mob-utilitiesheading">
                      Digital marketplace
                    </h3>
                    <p className="home_p mob-para ulities__para mob__paragraph">
                      Use $LITTLE on our digital marketplace, a global NFT
                      marketplace where $LITTLE is the means of payment for NFTs
                      from artists all around the globe.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="social list">
                  <li className="icon-text effecthov">
                    <img src={"images/utility3.png"} alt="util-imag" />
                  </li>

                  <li className="utility para">
                    <h3 className="utilities-head mob-utilitiesheading">
                      IPCO Possibilities
                    </h3>
                    <p className="home_p mob-para ulities__para mob__paragraph">
                      30 days after the NFT mint, $LITTLE will be offered in an
                      initial private coin offering for $0.15 / $LITTLE and then
                      listed on an external exchange.
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <ul className="social list">
                  <li className="icon-text effecthov">
                    <img src={"images/utility5.png"} alt="util-imag" />
                  </li>
                  <li className="utility para">
                    <h3 className="utilities-head mob-utilitiesheading">
                      Liquidity providing
                    </h3>
                    <p className="home_p mob-para ulities__para mob__paragraph">
                      Little Billionaires are providing liquidity of 250,000 USD
                      at 0.15$ on the external Exchange. 3% of transaction Fees
                      are used for liquidity as well.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="col-sm-6">
            <ul className="social-network social-circle">
              <li>
                <ul className="social list">
                  <li className="icon-text effecthov">
                    <img src={"images/utility2.png"} alt="util-imag" />
                  </li>
                  <li className="utility para">
                    <h3 className="utilities-head mob-utilitiesheading mob__paragraph">
                      Restribution System
                    </h3>
                    <p className="home_p mob-para ulities__para">
                      Receive rewards in MATIC tokens for holding your $LITTLE.
                      You can make an entry from $LITTLE 2,000 and receive daily
                      payable rewards in MATIC.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="social list">
                  <li className="icon-text effecthov">
                    <img src={"images/utility4.png"} alt="util-imag" />
                  </li>
                  <li className="utility para">
                    <h3 className="utilities-head mob-utilitiesheading">
                      $LITTLE Launchpad
                    </h3>
                    <p className="home_p mob-para ulities__para mob__paragraph">
                      Getting access to early-stage sales means a bargain price
                      for the investors before the public launch on the market.
                      As a $LITTLE holder, you get access to a specially
                      designed launchpad.
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <ul className="social list">
                  <li className="icon-text effecthov">
                    <img src={"images/utility6.png"} alt="util-imag" />
                  </li>
                  <li className="utility para">
                    <h3 className="utilities-head mob-utilitiesheading">
                      Swap function
                    </h3>
                    <p className="home_p mob-para ulities__para mob__paragraph">
                      We have developed an internal exchange function that can
                      be used to easily swap $LITTLE into MATIC and withdraw
                      them automatically.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Little Utilities */}

      {/* Ecosystem */}

      <div className="container-fluid mt-5 mb-3" id="ecosystem">
        <div className="row">
          <h2 className="heading mob-heading">$LITTLE Ecosystem</h2>
          <p className="para-sub new home_p mob-para-new">
            Join us on a new path of utility tokens and benefit from the $LITTLE
            ecosystem in every
            <br /> way you can imagine
          </p>
        </div>
        <div className="row liquidity mob-liquidity">
          <p className="utilitestitle">Liquidity and Rewarding System </p>
          <div className="col-md-3">
            <Mobroadmap />
          </div>
        </div>
        <div className="row supply_system mob-system">
          <p className="utilitestitle">Value and Supply System </p>
          <div className="col-md-3">
            <Mobroad />
          </div>
        </div>
      </div>

      {/* Ecosystem */}

      {/* Tokenomics  */}

      <div className="piechart">
        <center>
          <h2
            className="wow fadeInUp headings glitch heading"
            data-wow-delay=".75s"
          >
            Tokenization
          </h2>
        </center>

        <div className="token_heading">
          <p className="home_p">
            <strong className="strong_supply">Total Supply:</strong>{" "}
            100,000,000,000 $LITTLE
          </p>
          <p className="blockchain home_p">
            <strong className="strong_supply">Blockchain:</strong> ERC-20
          </p>
        </div>
        <div className="col-xl-5">
          <img className="chart-img" src={"images/LB_Logo1.png"} alt="chart" />
        </div>
        <div className="container pie_chart">
          <div className="row charts">
            <div className="col-xl-4 staking_list mob-staking">
              <div className="row mob-rows">
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <p className="list_para">Total supply</p>
                  <span className="supply_num home_p">100,000,000,000</span>
                </div>
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <p className="list_para">Staking</p>
                  <span className="supply_num home_p">700,000,000</span>
                </div>
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <p className="list_para">IPCO</p>
                  <span className="supply_num home_p">140,000,000</span>
                </div>
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <p className="list_para">Liquidity</p>
                  <span className="supply_num home_p">110,000,000</span>
                </div>
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <p className="list_para">Marketing</p>
                  <span className="supply_num home_p">40,000,000</span>
                </div>
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <p className="list_para">Team</p>
                  <span className="supply_num home_p">10,000,000</span>
                </div>
              </div>
              {/* <ul className="list_one">
                <li>
                  <div className="supply">
                    <p className="list_para">Total supply</p>
                    <span className="supply_num home_p">100,000,000</span>
                  </div>
                </li>
                <li>
                  <div className="staking">
                    <p className="list_para">Staking</p>
                    <span className="supply_num home_p">70,000,000</span>
                  </div>
                </li>
              </ul>

              <ul className="list_one">
                <li>
                  <div className="supply">
                    <p className="list_para">ICO</p>
                    <span className="supply_num home_p">14,000,000</span>
                  </div>
                </li>

                <li>
                  <div className="staking">
                    <p className="list_para">Liquidity</p>
                    <span className="supply_num home_p">10,000,000</span>
                  </div>
                </li>
              </ul>

              <ul className="list_one">
                <li>
                  <div className="supply">
                    <p className="list_para">Marketing</p>
                    <span className="supply_num home_p">4,000,000</span>
                  </div>
                </li>
                <li>
                  <div className="staking teams">
                    <p className="list_para">Team</p>
                    <span className="supply_num home_p">2,000,00</span>
                  </div>
                </li>
              </ul> */}
            </div>
            {/* <div className="col-xl-5">
              <img
                className="chart-img"
                src={"images/LB_Logo1.png"}
                alt="chart"
              />
                    </div> */}
            {/* <Chart
                width={"100%"}
                height={"400px"}
                chartType="PieChart"
                // loader={<div>Loading Pie Chart</div>}
                data={[
                  ["Task", "Hours per Day"],
                  ["", 10.8],
                  ["", 1.9],
                  ["", 1.6],
                  ["", 3.7],
                  ["", 6],
                ]}
                options={{
                  // title: 'Tokenization',
                  is3D: false,
                  pieHole: 0.4,
                  legend: {
                    textStyle: { color: "black" },
                  },
                  backgroundColor: "#fff",
                  colors: [
                    "#3a3d62",
                    "#005133",
                    "#63982B",
                    "#5e6682",
                    "#4c5171",
                  ],
                }}
              /> */}

            {/* <div className="col-xl-3 token_lists">
              <ul className="option-list" id="list_1">
                <li>
                  <button className="option-btn"></button>
                </li>
                <li>
                  <p className="strong">Staking:</p>
                </li>
                <li className="number-list">70,000,000</li>
              </ul>

              <ul className="option-list" id="list_2">
                <li>
                  <button className="option-btn btn-2"></button>
                </li>
                <li>
                  {" "}
                  <p className="strong">Staking:</p>
                </li>
                <li>
                  <li className="number-list">70,000,000</li>
                </li>
              </ul>

              <ul className="option-list" id="list_2">
                <li>
                  <button className="option-btn btn-2"></button>
                </li>
                <li>
                  {" "}
                  <p className="strong">ICO:</p>
                </li>
                <li>
                  <li className="number-list">14,000,000</li>
                </li>
              </ul>
              <ul className="option-list" id="list_3">
                <li>
                  <button className="option-btn btn-3"></button>
                </li>
                <li>
                  {" "}
                  <p className="strong">Liquidity:</p>
                </li>
                <li>
                  <li className="number-list">10,000,000</li>
                </li>
              </ul>
              <ul className="option-list" id="list_3">
                <li>
                  <button className="option-btn btn-4"></button>
                </li>
                <li>
                  {" "}
                  <p className="strong">Marketing:</p>
                </li>
                <li>
                  <li className="number-list">4,000,000</li>
                </li>
              </ul>
              <ul className="option-list" id="list_3">
                <li>
                  <button className="option-btn btn-5"></button>
                </li>
                <li>
                  {" "}
                  <p className="strong">Team:</p>
                </li>
                <li>
                  <li className="number-list">2,000,000</li>
                </li>
              </ul>
            </div> */}
            <div className="price_list">
              <ul className="price-phrase mob-phrase">
                <li>
                  <button className="mint-btn effecthov home_token">
                    <span>Fixed price after NFT mint:</span> 0.05$
                  </button>
                </li>
                <li>
                  <button className="mint-btn effecthov home_token button_2">
                    <span>IPCO Price phase 1:</span> 0.10$
                  </button>
                </li>
                <li>
                  <button className="mint-btn effecthov home_token">
                    <span>IPCO price phase 2:</span> 0.15$
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Tokenomics */}

      {/* Why little */}

      <div id="why" className="container-fluid mob-littletoken">
        <div className="row why_row">
          <h2 className="why-head heading">Why hold $LITTLE Token?</h2>
          <div className="col-sm-5 picture" style={{ margin: "auto" }}>
            <img src={"images/6.png"} className="why-pic floating" alt="float-imag" />
          </div>
          <div className="col-sm-7" style={{ margin: "auto" }}>
            <ul className="social-network social-circle">
              <li>
                <ul className="social">
                  <li className="icon-text effecthov">
                    <img src={"images/why1.png"} alt="why-imag" />
                  </li>
                  <li className="why para home_para mob-whypara">
                    <p>
                      Be compensated for holding $LITTLE on a daily basis with
                      MATIC in your wallet
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="social">
                  <li className="icon-text effecthov">
                    <img src={"images/why2.png"} alt="why-imag" />
                  </li>
                  <li className="why para home_para">
                    <p>
                      Constant liquidity providing through investing transaction
                      fees.
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <ul className="social">
                  <li className="icon-text effecthov">
                    <img src={"images/why3.png"} alt="why-imag" />
                  </li>
                  <li className="why para home_para">
                    <p>
                      Constant Value providing through investing royalties and
                      fees in buying and burning $LITTLE.
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <ul className="social">
                  <li className="icon-text effecthov">
                    <img src={"images/why4.png"} alt="why-imag" />
                  </li>
                  <li className="why para home_para">
                    <p>
                      IPCO price of 0.15$ 30 days after the mint while price is
                      fixed at 0.05$ directly after mint.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Why little */}

      {/* Footer */}

      <footer className="mainfooter" role="contentinfo">
        <div className="footer-middle">
          <div className="container footer">
            <div className="row footer">
              <div className="col-sm-6">
                {/* <!--Column1--> */}

                <div className="footer-pad mob-pad">
                  <Link to={"/"}>
                    <img
                      src={"images/logo.png"}
                      className="foot-logo mob_footlogo" alt="foot-logo-imag"
                    />
                  </Link>
                  <p className="foot-text">
                    7,777 unique billionaires who need owners.
                  </p>
                </div>
              </div>

              <div className="list-footer">
                <ul className="footer_list">
                  <li>
                    <div className="footer-pad">
                      <h4>DOWNLOAD</h4>
                      <ul className="list-unstyled">
                        <li>
                          {/* <Link to="/">Whitepaper</Link> */}
                          <a
                            href={Path + "Whitepaper_FINAL_1.1-2.pdf"}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Whitepaper
                          </a>
                        </li>
                        {/* <li><Link to="/">Login</Link></li>
            <li><Link to="/">Register</Link></li>
            <li><Link to="/">Dashboard</Link></li>
            <li><Link to="/">Forgot Password</Link></li> */}
                      </ul>
                    </div>
                  </li>

                  <li>
                    <div className="social_links">
                      <h4>Social</h4>
                      <ul className="social-network social-circle">
                        <li>
                          <Link to="/">
                            <ul
                              className="social icons_social"
                              onClick={() =>
                                window.open(
                                  "https://twitter.com/LittleBillions"
                                )
                              }
                            >
                              <li className="foot-social effecthov">
                                <img src={"images/twit-head.png"} alt="twitter-imag" />
                              </li>
                              <li className="foot-social">Twitter</li>
                            </ul>
                          </Link>
                        </li>
                        <li>
                          <Link to="/">
                            <ul
                              className="social icons_social"
                              onClick={() =>
                                window.open(
                                  "https://www.instagram.com/littlebillionaires.io/"
                                )
                              }
                            >
                              <li className="foot-social effecthov">
                                <img src={"images/insta-head.png"} alt="insta-imag" />
                              </li>
                              <li className="foot-social">Instagram</li>
                            </ul>
                          </Link>
                        </li>

                        <li>
                          <Link to="/">
                            <ul
                              className="social icons_social"
                              onClick={() =>
                                window.open("https://discord.gg/7UD5mSxSSW")
                              }
                            >
                              <li className="foot-social effecthov">
                                <img
                                  src={"images/dis-head.png"}
                                  style={{ marginTop: "-4px" }} alt="dis-imag"
                                />
                              </li>
                              <li className="foot-social">Discord</li>
                            </ul>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="row">
                <div className="col-md-12 copy">
                  <p className="text-center mob-pcenter">
                    &copy; Copyright 2022 - Little Billionaires. All rights
                    reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Footer */}

      {/* <Mobroadmap /> */}
    </>
  );
}
